import {useParams} from "react-router-dom";
export default function DiplomaTechcert() {
    let { token } = useParams()
    window.location = 'https://diplomadigital.techcert.com.br/validar/'+ token
    return (<></>);
}
